// export const Narendra_Modi_Election_API_URL = "https://mukeshpateleoffice.in/ElectionAPI/api/"
// export const Narendra_Modi_Election_PDF_API_URL = "https://mukeshpateleoffice.in/ElectionAPI/UploadFiles/ElectionResultPDF/"

export const Narendra_Modi_Election_API_URL = "https://narendramodieoffice.com/yojnaApi/api/";
// export const Narendra_Modi_Election_API_URL = "http://192.168.0.100:9917/api/";
export const Narendra_Modi_Election_PDF_API_URL = "https://narendramodieoffice.com/yojnaApi/UploadFiles/ElectionResultPDF/";

export const HIDE_ZERO_AMOUNT_YOJANA = ["आयुष्मान भारत-प्रधानमंत्री जन आरोग्य योजना (AB-PMJAY)"];
